export default __webpack_public_path__ + "static/media/sample-fest.f6a0a82f.png";